import { GLSL_ARG } from "../typeMapping";
import { toArray } from "./index";
export default [
    {
        name: "src",
        type: "src",
        inputs: [
            {
                type: "sampler2D",
                name: GLSL_ARG.tex,
                default: NaN,
            },
        ],
        glsl: `return _tex(${GLSL_ARG.tex}, fract(${GLSL_ARG.st}.xy));`,
        lang: "$",
    },
    {
        name: "noise",
        type: "src",
        inputs: {
            scale: 10,
            speed: 0.1,
            offset: [0, 0, 0],
        },
        glsl: `
			vec3 p = (${GLSL_ARG.st} + offset) * scale;

			float z = p.z + speed * time;

			vec2 r_offset = vec2(4.21, -1.57) * offset.x;
			vec2 g_offset = vec2(1.57, -4.21) * offset.y;
			vec2 b_offset = vec2(-2.34, 7.85) * offset.z;

			float r = noise3d(p.xy + r_offset, z);
			float g = noise3d(p.xy + g_offset, z);
			float b = noise3d(p.xy - b_offset, z);

			return vec4(r, g, b, 1.0);
		`,
        require: ["noise3d"],
        transform: (scale, speed, offset) => {
            return [scale, speed, toArray(offset, 3)];
        },
    },
    {
        name: "osc",
        type: "src",
        inputs: {
            frequency: 60,
            sync: 0.1,
            offset: 0.0,
        },
        glsl: `
			vec2 st = ${GLSL_ARG.st}.xy;
			float r = sin((st.x-offset/frequency+time*sync)*frequency)*0.5  + 0.5;
			float g = sin((st.x+time*sync)*frequency)*0.5 + 0.5;
			float b = sin((st.x+offset/frequency+time*sync)*frequency)*0.5  + 0.5;

            return vec4(r, g, b, 1.0);
        `,
    },
    {
        name: "shape",
        type: "src",
        inputs: {
            sides: 3,
            radius: 0.3,
            smoothing: 0.005,
        },
        glsl: `
			vec3 st = ${GLSL_ARG.st} * 2. - 1.;
			// Angle and radius from the current pixel
			float a = atan(st.x, st.y) + PI;
			float r = TWO_PI / sides;
			float d = cos(floor(.5 + a/r) * r-a) * length(st.xy);
			float color = 1.0 - smoothstep(radius, radius + smoothing + 0.000000001, d);
			
			return vec4(vec3(color), 1.0);
		`,
        defines: ["TWO_PI", "PI"],
    },
    {
        name: "gradient",
        type: "src",
        inputs: {
            speed: 0,
        },
        glsl: `return vec4(${GLSL_ARG.st}.xy, sin(time * speed), 1.0);`,
    },
    {
        name: "voronoi",
        type: "src",
        inputs: {
            scale: 5,
            speed: 0.3,
            blending: 0.3,
        },
        glsl: `   
			vec2 st = ${GLSL_ARG.st}.xy;
			
			vec3 color = vec3(.0);
		 	// Scale
		 	st *= scale;
		 	
			// Tile the space
			vec2 ist = floor(st);
			vec2 fst = fract(st);

			float m_dist = 10.;  // minimun distance
			vec2 m_point;        // minimum point

			for (int j=-1; j<=1; j++ ) {
				for (int i=-1; i<=1; i++ ) {
					vec2 neighbor = vec2(float(i), float(j));
					vec2 p = ist + neighbor;
					vec2 point = fract(sin(vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))))*43758.5453);
					point = 0.5 + 0.5  * sin(time*speed + 6.2831*point);
					vec2 diff = neighbor + point - fst;
					float dist = length(diff);
					if( dist < m_dist ) {
						m_dist = dist;
						m_point = point;
					}
				}
			}
			
			// Assign a color using the closest point position
			color += dot(m_point,vec2(.3,.6));
			color *= 1.0 - blending*m_dist;
			
			return vec4(color, 1.0);
		`,
    },
    {
        name: "solid",
        type: "src",
        inputs: {
            r: 0,
            g: 0,
            b: 0,
            a: 1,
        },
        glsl: `return vec4(r, g, b, a);`,
        transform: (...args) => {
            if (args.length === 1 && typeof args[0] === "string") {
                let hex = args[0].replace("#", "");
                if (hex.length === 3) {
                    hex = hex
                        .split("")
                        .map(v => v + v)
                        .join("");
                }
                const r = parseInt(hex.substring(0, 2), 16) / 255;
                const g = parseInt(hex.substring(2, 4), 16) / 255;
                const b = parseInt(hex.substring(4, 6), 16) / 255;
                return [r, g, b];
            }
            return args;
        },
    },
];
